/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaxCheckAirport } from './PaxCheckAirport';
import {
    PaxCheckAirportFromJSON,
    PaxCheckAirportFromJSONTyped,
    PaxCheckAirportToJSON,
    PaxCheckAirportToJSONTyped,
} from './PaxCheckAirport';

/**
 * Arrival point - API output
 * @export
 * @interface PaxCheckArrivalPoint
 */
export interface PaxCheckArrivalPoint {
    /**
     * 
     * @type {PaxCheckAirport}
     * @memberof PaxCheckArrivalPoint
     */
    airport: PaxCheckAirport;
    /**
     * Date and time of arrival (local)
     * @type {string}
     * @memberof PaxCheckArrivalPoint
     */
    arrivalDatetime: string;
    /**
     * ISO 3166-1 alpha-3 country code
     * @type {string}
     * @memberof PaxCheckArrivalPoint
     */
    countryCode: string;
}

/**
 * Check if a given object implements the PaxCheckArrivalPoint interface.
 */
export function instanceOfPaxCheckArrivalPoint(value: object): value is PaxCheckArrivalPoint {
    if (!('airport' in value) || value['airport'] === undefined) return false;
    if (!('arrivalDatetime' in value) || value['arrivalDatetime'] === undefined) return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    return true;
}

export function PaxCheckArrivalPointFromJSON(json: any): PaxCheckArrivalPoint {
    return PaxCheckArrivalPointFromJSONTyped(json, false);
}

export function PaxCheckArrivalPointFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckArrivalPoint {
    if (json == null) {
        return json;
    }
    return {
        
        'airport': PaxCheckAirportFromJSON(json['airport']),
        'arrivalDatetime': json['arrival_datetime'],
        'countryCode': json['country_code'],
    };
}

export function PaxCheckArrivalPointToJSON(json: any): PaxCheckArrivalPoint {
    return PaxCheckArrivalPointToJSONTyped(json, false);
}

export function PaxCheckArrivalPointToJSONTyped(value?: PaxCheckArrivalPoint | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'airport': PaxCheckAirportToJSON(value['airport']),
        'arrival_datetime': value['arrivalDatetime'],
        'country_code': value['countryCode'],
    };
}

